import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RegisterPage({ language = 'en' }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    birthDate: '',
    password: ''
  });

  const labels = {
    en: {
      title: 'Create Your Account',
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      birthDate: 'Date of Birth',
      password: 'Password',
      register: 'Register',
      back: 'Back to Home'
    },
    es: {
      title: 'Crea Tu Cuenta',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Número de teléfono',
      birthDate: 'Fecha de nacimiento',
      password: 'Contraseña',
      register: 'Registrarse',
      back: 'Volver al Inicio'
    },
    pt: {
      title: 'Crie Sua Conta',
      fullName: 'Nome completo',
      email: 'Email',
      phone: 'Número de telefone',
      birthDate: 'Data de nascimento',
      password: 'Senha',
      register: 'Registrar',
      back: 'Voltar ao Início'
    }
  };

  const t = labels[language];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se integrará lógica de registro más adelante
    console.log('Registered:', formData);
  };

  return (
    <>
      {/* Encabezado con separación del header */}
      <section
        id="register"
        className="bg-[#48887B] py-12 text-center scroll-mt-[120px] pt-[120px]"
      >
        <h2 className="text-white text-3xl md:text-5xl font-bold">
          {t.title}
        </h2>
      </section>

      <div className="max-w-3xl mx-auto py-12 px-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-1 font-medium" htmlFor="fullName">{t.fullName}</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              required
              value={formData.fullName}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium" htmlFor="email">{t.email}</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium" htmlFor="phone">{t.phone}</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              required
              value={formData.phone}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium" htmlFor="birthDate">{t.birthDate}</label>
            <input
              type="date"
              id="birthDate"
              name="birthDate"
              required
              value={formData.birthDate}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium" htmlFor="password">{t.password}</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              value={formData.password}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>

          <button
            type="submit"
            className="px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition"
          >
            {t.register}
          </button>
        </form>

        <button
          onClick={() => navigate('/')}
          className="mt-6 block px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
        >
          {t.back}
        </button>
      </div>
    </>
  );
}
